export default "__VITE_ASSET__AGbm0kyV__"